<template>
  <div>
    <div class="dropdown">
      <button
        id="dropdownMenuButton"
        class="btn dropdown-toggle"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :style="stiloDropDown"
        @click="toogleItensMenu"
      />
      <div
        id="itensDoDropDownMenuChat"
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
      >
        <div
          v-if="chatAtual.tipo == 'LEAD'"
          class="dropdown-item"
          @click="mostrarLeadInfos"
        >Lead infos</div>
        <div
          v-if="chatAtual.tipo == 'LEAD'"
          class="dropdown-item"
          @click="mostrarLeadtransfer"
        >Transfer</div>
        <div
          @click="finalizar"
          class="dropdown-item"
          v-if="chatAtual.tipo == 'LEAD' || chatAtual.tipo == 'GROUP' || usuarioLogado.roles == 'A'"
        >End Chat</div>
        <div
          v-if="usuarioLogado.roles == 'A' && chatAtual.tipo == 'GROUP'"
          class="dropdown-item"
          @click="mostrarChatAddUser"
        >Add user</div>
        <div
          v-if="usuarioLogado.roles == 'A' && chatAtual.tipo == 'GROUP'"
          class="dropdown-item"
          @click="mostrarChatRemoveUser"
        >Remove user</div>
      </div>
    </div>
    <ModalRemoverUsuario ref="modalRemoverUsuario" />
    <ModalInformacoesLead ref="modalInformacoesLead" />
    <ModalTransferirChatDeUsuario ref="ModalTransferirChatDeUsuario"/>
    <ModalAdicionarUsuario ref="modalAdicionarUsuario" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalRemoverUsuario from './modalRemoverUsario/ModalRemoverUsuario.vue';
import ModalInformacoesLead from './modalInformacoesLead/ModalInformacoesLead.vue';
import ModalAdicionarUsuario from './modalAdicionarUsuario/ModalAdicionarUsuario.vue';
import ModalTransferirChatDeUsuario from './modalTransferirChatDeUsuario/modalTransferirChatDeUsuario.vue';

export default {
  props: {
    cores: {
      type: Object,
      default: null,
      required: false,
    },
  },
  components: {
    ModalRemoverUsuario,
    ModalInformacoesLead,
    ModalTransferirChatDeUsuario,
    ModalAdicionarUsuario,
  },
  computed: {
    ...mapGetters(['chatsUsuario', 'usuarioLogado', 'chatAtual', 'coresChat']),
    stiloDropDown() {
      // se campo so eh passado para testar as cores no mudifica o layout
      if (this.cores) {
        return {
          color: `${
            this.cores.menu.icon ? this.cores.menu.icon : '#fff'
          } !important`,
          'background-color': `${
            this.cores.menu.bg ? this.cores.menu.bg : '#20a8d8'
          } !important`,
          'border-color': `${
            this.cores.menu.bg ? this.cores.menu.bg : '#20a8d8'
          } !important`,
        };
      }
      const coresPadrao = {
        color: '#fff !important',
        'background-color': '#20a8d8 !important',
        'border-color': '#20a8d8 !important',
      };

      if (this.coresChat && this.coresChat.value) {
        const cores = JSON.parse(this.coresChat.value);
        if (cores.menu) {
          return {
            color: `${cores.menu.icon ? cores.menu.icon : '#fff'} !important`,
            'background-color': `${
              cores.menu.bg ? cores.menu.bg : '#20a8d8'
            } !important`,
            'border-color': `${
              cores.menu.bg ? cores.menu.bg : '#20a8d8'
            } !important`,
          };
        }
      }
      return coresPadrao;
    },
  },
  methods: {
    ...mapActions(['finalizarChat']),
    async finalizar() {
      try {
        const dadosParaFinalizar = {
          idChat: this.chatAtual.id,
          emailUsuarioLogado: this.usuarioLogado.email,
          usuarioName: this.usuarioLogado.stNome,
        };

        await this.finalizarChat(dadosParaFinalizar);
        this.$forceUpdate();
      } catch (error) {
        console.log(error);
      }
    },
    mostrarChatRemoveUser() {
      this.$refs.modalRemoverUsuario.toogleModal();
      this.hideItensMenu();
    },
    mostrarChatAddUser() {
      this.$refs.modalAdicionarUsuario.toogleModal();
      this.hideItensMenu();
    },
    mostrarLeadInfos() {
      this.$refs.modalInformacoesLead.toogleModal();
      this.hideItensMenu();
    },
    mostrarLeadtransfer() {
      this.$refs.ModalTransferirChatDeUsuario.toogleModal();
      this.hideItensMenu();
    },
    toogleItensMenu() {
      const element = document.getElementById('itensDoDropDownMenuChat');
      if (!element) {
        console.log('Elemento do dropdown nao encontrado');
        return;
      }
      if (element.classList.contains('show')) {
        element.classList.remove('show');
      } else {
        element.classList.add('show');
      }
    },
    hideItensMenu() {
      const element = document.getElementById('itensDoDropDownMenuChat');
      if (!element) {
        console.log('Elemento do dropdown nao encontrado');
        return;
      }
      if (element.classList.contains('show')) {
        element.classList.remove('show');
      }
    },
  },
};
</script>

<style scoped>
.btn-secondary {
  color: #fff !important;
  background-color: #20a8d8 !important;
  border-color: #20a8d8 !important;
}
</style>
